"use strict";
/**
 * @packageDocumentation
 * @module DelegationRootNode
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.revoke = exports.query = exports.store = void 0;
const tslib_1 = require("tslib");
const chain_helpers_1 = require("@kiltprotocol/chain-helpers");
const DelegationDecoder_1 = require("./DelegationDecoder");
const DelegationRootNode_1 = tslib_1.__importDefault(require("./DelegationRootNode"));
/**
 * @param delegation
 * @internal
 */
async function store(delegation) {
    const blockchain = await chain_helpers_1.BlockchainApiConnection.getConnectionOrConnect();
    const tx = blockchain.api.tx.delegation.createRoot(delegation.id, delegation.cTypeHash);
    return tx;
}
exports.store = store;
/**
 * @param delegationId
 * @internal
 */
async function query(delegationId) {
    const blockchain = await chain_helpers_1.BlockchainApiConnection.getConnectionOrConnect();
    const decoded = DelegationDecoder_1.decodeRootDelegation(await blockchain.api.query.delegation.root(delegationId));
    if (decoded) {
        const root = new DelegationRootNode_1.default({
            id: delegationId,
            cTypeHash: decoded.cTypeHash,
            account: decoded.account,
            revoked: decoded.revoked,
        });
        return root;
    }
    return null;
}
exports.query = query;
/**
 * @internal
 *
 * Revokes a full delegation tree, also revoking all constituent nodes.
 *
 * @param delegation The [[DelegationRootNode]] node in the delegation tree at which to revoke.
 * @param maxRevocations The maximum number of revocations that may be performed. Should be set to the number of nodes (including the root node) in the tree. Higher numbers result in a larger amount locked during the transaction, as each revocation adds to the fee that is charged.
 * @returns Unsigned [[SubmittableExtrinsic]] ready to be signed and dispatched.
 */
async function revoke(delegation, maxRevocations) {
    const blockchain = await chain_helpers_1.BlockchainApiConnection.getConnectionOrConnect();
    const tx = blockchain.api.tx.delegation.revokeRoot(delegation.id, maxRevocations);
    return tx;
}
exports.revoke = revoke;
